// Initialize window.api with IndexedDB implementation
import { searchItemsAsync, getItemCountAsync, getItemPriceAsync, getTaxRateAsync, calculateItemPriceAsync } from './database';
import { useAuthStore } from '@/app/store/authStore';

export function initializeWindowApi() {
  if (typeof window === 'undefined') return;

  // Create window.api if it doesn't exist
  if (!window.api) {
    window.api = {} as any;
  }

  // Implement IndexedDB-based methods
  window.api.searchItems = async (query: string, limit: number = 50) => {
    const organizationId = useAuthStore.getState().userOrgId;
    if (!organizationId) {
      throw new Error('No organization selected');
    }
    return searchItemsAsync(query, organizationId, limit);
  };

  window.api.getItemCount = async () => {
    const organizationId = useAuthStore.getState().userOrgId;
    if (!organizationId) {
      throw new Error('No organization selected');
    }
    return getItemCountAsync(organizationId);
  };

  window.api.getItemPrice = async (itemId: number, priceType: string, siteId?: number | null) => {
    // Convert price type to our expected format
    const normalizedPriceType = priceType.toLowerCase().replace('_price', '') as 'sale' | 'purchase' | 'mrp';
    const price = await getItemPriceAsync(itemId, normalizedPriceType, siteId);
    return price;
  };

  window.api.getTaxRate = async (itemId: number) => {
    return getTaxRateAsync(itemId);
  };

  // Add new method for calculating price with quantity rules
  window.api.calculateItemPrice = async (itemId: number, quantity: number, siteId?: number | null) => {
    const result = await calculateItemPriceAsync(itemId, quantity, 'sale', siteId);
    return result ? result.price : null;
  };

  console.log('[initializeWindowApi] window.api initialized with IndexedDB implementation');
}